import React from 'react';
import ScanCart from './ScanCart';
import ScanProduct from './ScanProduct';
import Packs from './Packs';
import AuthStore from '../stores/AuthStore';
import StateStore from '../stores/StateStore';
import LoginForm from './LoginForm';
import Variants from './Variants';
import Pakowanie from './Pakowanie';
import Boxes from './Boxes';
import Done from './Done';

class IndexComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      authenticated: AuthStore.isAuthenticated(),
      pack: StateStore.getPack(),
      is_multi: StateStore.getIsMulti(),
      variants: AuthStore.variants,
      order: StateStore.getOrder(),
      config: AuthStore.getConfig(),
      done: StateStore.getDone()
    }
    this.onStateChange = this.onStateChange.bind(this);
    this.productRouter = this.productRouter.bind(this);
  }

  onStateChange() {
    this.setState({
      pack: StateStore.getPack(),
      is_multi: StateStore.getIsMulti(),
      variants: StateStore.getVariants(),
      order: StateStore.getOrder(),
      done: StateStore.getDone()
    });
  }

  componentWillMount() {
    StateStore.addChangeListener(this.onStateChange);
  }

  componentWillUnmount() {
    StateStore.removeChangeListener(this.onStateChange);
  }

  productRouter() {
    if(this.state.done){
      return (<Done/>)
    }
    if (this.state.variants || this.state.order){
      if (Object.keys(this.state.variants).length>1){
        return (<Variants/>)
      } else {
        return (<Pakowanie/>)
      }
    } else {
      if (this.state.is_multi){
        return (<Boxes/>)
      } else {
        return (<ScanProduct/>)
      }
    }
  }

  render() {
    return (
      <div>
        { !this.state.authenticated ? (
          <LoginForm/>
        ) : (
          this.state.pack ? (
            this.productRouter()
          ) : (
            this.state.config.no_packages ? (
            this.productRouter()
            ) : (
              this.state.config.wozek ? (
              <ScanCart/>
              ) : (
                <Packs/>
              )
            )
          )
        )}
      </div>
    );
  }
}

export default IndexComponent;



// WEBPACK FOOTER //
// ./src/components/Index.js